import { render, staticRenderFns } from "./AppTriggers.vue?vue&type=template&id=56852d95"
import script from "./AppTriggers.vue?vue&type=script&lang=ts"
export * from "./AppTriggers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports